import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Profile from "./profile";
import ArtistStandaloneSettings from "./ArtistStandaloneSettings";
import YourAotdsPanel from "./YourAotdsPanel";
import AotdStatsBox from "./AotdStatsBox";
import RivalryLine from "./RivalryLine";
import TelegramSettings from "./TelegramSettings";
import WebPushSettings from "./WebPushSettings";
import HapticsSettings from "./HapticsSettings";
import FeatureEmailSettings from "./FeatureEmailSettings";
import PreferencesBox from "./preferences-box";
import InvitePanel from "./InvitePanel";
import { useLocation } from "react-router";
import { BadgeShowcase } from "../../features/badges/profile";
import ShippedIdeasPanel from "../contribute/ShippedIdeasPanel";
import BirthdayButton from "../birthday_button/BirthdayButton";
import PendingActions from "../pending_actions/PendingActions";
import { useAppSelector } from "../../store/hooks";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #c9febe;
  align-items: center;
  padding: 15px;
  height: auto;
  min-height: 100vh;
`;

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #c9febe;
  align-items: center;
  padding: 15px;
  height: auto;
  min-height: 100vh;
  max-width: 900px;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #222;
  margin-bottom: 1rem;
  align-self: flex-start;
  margin-left: 30px;
  margin-bottom: 0px;
`;

const Description = styled.p`
  font-size: 1rem;
  color: #555;
  max-width: 800px;
  text-align: center;
  margin-top: -8px;
  /* margin-bottom: 2rem; */
`;

function checkRole(str: string, searchStr: string) {
  try {
    var arr = str.split(",");
  } catch {
    return false;
  }
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].trim() === searchStr) {
      return true;
    }
  }
  return false;
}

const ProfilePage: React.FC = () => {
  const [userId, setUserId] = useState<string>("");
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const location = useLocation();

  const showPreferencesBox = new URLSearchParams(location.search).get('p') === '1';
  const user = useAppSelector((state) => state.auth);


  useEffect(() => {
    document.title = `NΛSOS Your Profile`;
    if (user._id) {
      setUserId(user._id);
    }
    if (checkRole(user.role || '', 'admin') || checkRole(user.role || '', 'ai-manager')) {
      setIsAdmin(true);
    }
  }, [user]);

  // log isAdmin in separate effect to see updated value
  useEffect(() => {
    if (isAdmin) {
      console.log("isAdmin", isAdmin);
    }
  }, [isAdmin]);

  return (
    <PageContainer>
      <ProfileContainer>
        <Title>Your Profile</Title>
        <PendingActions placement="profile" />
        <Profile />
        <Description>
          You can change your username, email, and password from the edit screen.
          Note that you can only change your username once.
          <br />
        </Description>
        <AotdStatsBox />
        <RivalryLine />
        <YourAotdsPanel />
        <ArtistStandaloneSettings />
        <TelegramSettings />
        <WebPushSettings />
        <HapticsSettings />
        <FeatureEmailSettings />
        {showPreferencesBox && <PreferencesBox />}
        <BirthdayButton />
        <InvitePanel />
        <Title>Your Badges</Title>
        <BadgeShowcase />
        <ShippedIdeasPanel username={user.username || ""} />
      </ProfileContainer>
    </PageContainer>
  );
};

export default ProfilePage;
